import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { uniqueIdentificationGenerator } from '../../utils/uniqueIdentificationGenerator'

import warningIcon from 'images/warning-icon.svg'
import errorIcon from 'images/error-icon.svg'
import successIcon from 'images/success-icon.svg'

class FileInput extends Component {
  static propTypes = {
    /* The input placeholder */
    placeholder: PropTypes.string,

    /* The input accepted file types */
    accept: PropTypes.string,

    /* The text that will be displayed along with the input */
    label: PropTypes.string,

    errorOnStruct: PropTypes.bool,

    hideFileInput: PropTypes.bool,

    /* The input name */
    name: PropTypes.string,

    /* The input id */
    id: PropTypes.string,

    /* The text that will be displayed below the input */
    helpText: PropTypes.string,

    /* The text that will be displayed below the input when the input is valid */
    successText: PropTypes.string,

    /* The text that will be displayed below the input when an error is found */
    errorText: PropTypes.string,

    /* The text that will be displayed below the input when an warning need to be displayed */
    warningText: PropTypes.string,

    /* The element classes */
    className: PropTypes.string,

    /* Initial file */
    file: PropTypes.string,

    /* Callback for when the input changes */
    onChange: PropTypes.func,

    /* Determine if the input is or not required */
    required: PropTypes.bool,

    /* Determine if the input is or not disabled */
    disabled: PropTypes.bool,

    /* Determine if the input is or not readonly */
    readOnly: PropTypes.bool,

    /* Function that will be triggered when the value changes. May return true or false to wheter the new value is or not valid */
    validateValue: PropTypes.func,

    resetValue: PropTypes.bool,

    cleanFile: PropTypes.bool,

    /* Show an "x" (times) icon to clear the selected file */
    showClearFile: PropTypes.bool,

    /* Callback when the clear icon is clicked */
    onClearFile: PropTypes.func,
  }

  state = {
    /* The input file  */
    file: this.props.file || '',

    /* Stores the information of wheter the input is or not valid  */
    isValid: null,
  }

  

  fileUpload = React.createRef()

  showFileUpload = this.showFileUpload.bind(this)


  componentDidUpdate(prevProps) {
    if(this.props.cleanFile === true && prevProps.cleanFile === false) { 
      this.setState({file: '', isValid: null})
    }
  } 

  showFileUpload() {
    this.fileUpload.current.click()
  }

  getClasses() {
    const { disabled, readOnly } = this.props
    const { isValid } = this.state
    return `
            ${disabled ? 'disabled' : ''}
            ${isValid === false ? 'invalid' : ''}
            ${isValid === true ? 'valid' : ''}
            ${readOnly ? 'read-only' : ''}
        `
  }

  onChange(file) {
    const { onChange = () => {} } = this.props
    this.setState(
      {
        file: file[0],
        isValid: this.valueIsValid(file),
      },
      onChange(file)
    )
  }

  valueIsValid(file) {
    const { validateValue } = this.props

    if (validateValue) {
      return validateValue(file)
    }
    return true
  }

  textHelperDisplay() {
    const { errorText, warningText, helpText, successText, errorOnStruct = false } = this.props
    const { isValid } = this.state

    if (isValid === true && !errorOnStruct) {
      if (successText)
        return ['success', <img key='successIcon' src={successIcon} />, successText]
    } else if (isValid !== false && !errorOnStruct) {
      if (helpText) return ['default', null, helpText]
    } else {
      if (errorText || errorOnStruct) {
        return ['error', <img key='errorIcon' src={errorIcon} />, errorText]
      }
      if (warningText) {
        return ['warning', <img key='warningIcon' src={warningIcon} />, warningText]
      }
    }
    return ['', null, null]
  }

  onInputClick = (event) => {
    event.target.value = ''
  }

  render() {
    const {
      label,
      name,
      required,
      disabled,
      className,
      id,
      placeholder,
      hideFileInput,
      accept,
      resetValue = false
      , showClearFile = false,
      onClearFile,
    } = this.props
    const { file } = this.state

    const customId = id || uniqueIdentificationGenerator('input-text_')
    const customName = name || uniqueIdentificationGenerator('input-text_')
    const classes = this.getClasses()
    const [validationClass, smallIcon, smallText] = this.textHelperDisplay()

    return (
      <>
        <div style={{display: hideFileInput && 'none'}} className={`file-input-container ${validationClass} ${classes}`}>
          {label && (
            <label>
              {label}
              {required !== true && <i> - opcional</i>}
            </label>
          )}
          <div className='file-input'>
            <input
              type='file'
              id={customId}
              name={customName}
              disabled={disabled}
              accept={accept}
              required={required}
              className={className}
              filename={file && file.name}
              placeholder={placeholder}
              onChange={(e) => this.onChange(e.target.files)}
              onClick={resetValue && this.onInputClick}
              ref={this.fileUpload}
            />
            <span className='file-input-filename'>{file ? file.name : "Escolha um arquivo"}</span>
            <button onClick={this.showFileUpload}>Escolher arquivo</button>
            {showClearFile && onClearFile && (
              <span
                className='times'
                onClick={(e) => {
                  e.stopPropagation()
                  onClearFile()
                }}
                title='Remover arquivo'
              >
                ×
              </span>
            )}
          </div>
          {smallText && (
            <small className={validationClass}>
              {smallIcon}
              {smallText}
            </small>
          )}
        </div>
      </>
    )
  }
}

export default FileInput
